import { ICardDriverRanking } from '@sky-it-livedata/livedata-sports-design-system';

import { competitionNameMap } from '../../../types/data-cards';
import { DataCardDriverRanking } from '../types';
import { intcmpMap } from '../../../utils/intcmp';
import { isValidDataCardDriverRanking } from './typeguards';
import { CardDriverRankingDriverInfo, CreateCardDriverRankingWidgetInputSchema } from 'cdk/graphql';
import { ErrorName, WidgetError } from '../../../utils/errors';

export default (obj: DataCardDriverRanking): ICardDriverRanking => {
  if (isValidDataCardDriverRanking(obj)) {
    CreateCardDriverRankingWidgetInputSchema().parse(obj.data.getCardDriverRankingWidget, {reportInput: true});

    const { customCompetitionName, rankingLink, drivers } = obj.data.getCardDriverRankingWidget;
    const competitionName = `Piloti ${competitionNameMap.get(customCompetitionName)}`;

    return {
      competitionName,
      readMoreLink: rankingLink,
      drivers: drivers!.map<ICardDriverRanking['drivers'][0]>((driverObj) => {
        const driver = driverObj as CardDriverRankingDriverInfo;
        
        return {
          driverName: `${driver.customDriverSurname} ${(driver.customDriverName as string).charAt(0)}.`,
          logoUrl: driver.flagUrl,
          points: driver.pts,
          position: driver.pos as string,
          targetUrl: driver.customDriverPageUrl,
          title: `Posizione: ${driver.pos}; ${driver.customDriverName} ${driver.customDriverSurname}; Punti: ${driver.pts};`,
          trackingData: { intcmp: intcmpMap.dataCardDriverRanking.detailLink },
        };
      }),
      trackingData: { 'analytics-element': `card-driver-ranking-motorsport-formula1` },
      cardCtaTrackingData: {
        intcmp: intcmpMap.dataCardDriverRanking.viewAllCta,
      },
    } as ICardDriverRanking;
  } else {
      throw new WidgetError<ErrorName>({
        name: 'NO_VALID_DATA',
        message: 'Invalid transformer input, Error in DataCardDriverRanking object',
        data: obj
      });
    }
};
